var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "msg-subscr-msanage" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "message-body" }, [
      _c("ul", { staticClass: "native-table" }, [
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _vm.assetType != 2 && _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("统一商品代码(UPC)")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("-")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "table-tr" }, [
          _c(
            "div",
            { staticClass: "table-td", staticStyle: { "text-align": "left" } },
            [
              _vm._v(
                _vm._s(_vm.assetType != 2 ? "资产" : "耗材描述全") + "名称"
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table-td" }, [
            _vm._v(_vm._s(_vm.assetType != 2 ? "是" : "-"))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-td", staticStyle: { "text-align": "left" } },
            [
              _vm._v(
                "不能超过60个字符，" +
                  _vm._s(
                    _vm.assetType != 2
                      ? "从定义带入以定义为准"
                      : "不填写从定义带入"
                  )
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "table-td",
            staticStyle: { "text-align": "left" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "table-td" }, [_vm._v("此行无效")])
        ]),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("启用日期")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("格式 yyyy-MM-dd")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("2019-01-01")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType == 2 || _vm.assetType == -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("商品分类")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("商品分类不可为空（从定义带入以定义为准）")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("此行无效")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType == 2 || _vm.assetType == -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("商品品牌")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [
                  _vm._v(
                    "从定义带入以定义为准（如果不选择任何品牌，系统会默认为无名公共）"
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("此行无效")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType == 2 || _vm.assetType == -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("型号")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("从定义带入以定义为准")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType == 2 || _vm.assetType == -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("规格")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("从定义带入以定义为准")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("供商统一社会信用码")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("-")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("厂商序列号")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [
                  _vm._v(
                    "商户内唯一，如填写厂商序列号，数量必须为1（针对单品）"
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("是否批量")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("不填写默认为否，从定义带入以定义为准")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("检验设备")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("不填写默认为否")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("需巡查设备")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("不填写默认为否")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("需保养设备")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("不填写默认为否")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("是否可出租")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("不填写默认为否")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("收货日期")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("格式 yyyy-MM-dd")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("2019-01-01")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(7),
        _vm._v(" "),
        _vm.assetType == 2 || _vm.assetType == -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("单位")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [
                  _vm._v(
                    "系统对每类资产有一个默认分类，不填写的情况下直接使用此单位。商户应对每类每批次定一个固定单位"
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("质保期（月）")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("必须是大于0的整数,不能为小数")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("1、2、3")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("入账方式")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("可在系统中进行选择，或者导入之后，后续进行手工操作")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2 && _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("原值(元)")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [
                  _vm._v(
                    "必须是大于等于0的数字,可以为小数。包含（含税单价、物流单价、安装单价）"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("24.67")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2 && _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("入账日期")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("格式 yyyy-MM-dd")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("2019-01-01")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [
                _vm._v("无法解析文件、验证不通过")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2 && _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("购置日期")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("格式 yyyy-MM-dd")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("2019-01-01")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2 && _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("折旧起算日期")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("格式 yyyy-MM-dd")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("2019-01-01")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2 && _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("累计折旧值(元)")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("单个的累计折旧值，必须是大于0的整数，可以为小数")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("34")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2 && _vm.assetType != -1
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("最后折旧月份")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("格式 yyyy-MM，截止目前已经折旧的月份")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("2019-01")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(8),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("责任部门编码")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("可在系统中进行选择，或者导入之后，后续进行手工操作")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(9),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("责任人编码")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("可在系统中进行选择，或者导入之后，后续进行手工操作")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(10),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("备注1")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("-")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("备注2")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("-")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetType != 2
          ? _c("li", { staticClass: "table-tr" }, [
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("备注3")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-td",
                  staticStyle: { "text-align": "left" }
                },
                [_vm._v("-")]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "table-td" }, [_vm._v("-")])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint block mb10" }, [
      _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
      _vm._v(" "),
      _c("p", [_vm._v("逐条检查：一条一条的检查，因数据较多花费时间较长")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("导入excel文件的单元格格式推荐使用常规或文本")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-th", staticStyle: { "text-align": "left" } },
        [_vm._v("列名")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "120px" } }, [
        _vm._v("是否必填")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-th", staticStyle: { "text-align": "left" } },
        [_vm._v("其他要求")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-th", staticStyle: { "text-align": "left" } },
        [_vm._v("正确示例")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("批次号")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("可在系统中进行选择或手动输入")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("资产编号")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [
          _vm._v(
            "可在系统中进行选择或手动输入(注意：单品式管理的资产入库数量大于1的时候，资产编号不能自动生成，保存的时候以后台系统生成为主)"
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("定义编码")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("可在系统中进行选择")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("业务单元")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("必须与导入业务单元一致")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("此行无效")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("所属部门")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("必须与导入所属部门一致")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("此行无效")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("数量")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("必须是大于0的整数,不能为小数")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("1、2、3")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("无法解析文件")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("责任部门")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("可在系统中进行选择，或者导入之后，后续进行手工操作")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("责任人")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("可在系统中进行选择，或者导入之后，后续进行手工操作")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("备注")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-td", staticStyle: { "text-align": "left" } },
        [_vm._v("-")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "table-td",
        staticStyle: { "text-align": "left" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [_vm._v("-")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a24aa6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a24aa6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceFormatExpl.vue
// module id = 2230
// module chunks = 0